import { Col, Divider, Row } from 'antd';
import { useEffect, useState } from 'react';

import Search from 'antd/es/input/Search';
import { useNavigate } from 'react-router-dom';
import { Return } from '../../Components/Button/button';
import { ACCIDENT_ROUTE } from '../../Components/Router/constant';
import { useFormContext } from '../../Context/DeclarationContext';
import { getDeteailsVehicleByPantent } from '../../Services/declarations';
import './search.scss';

export const SearchComponent = () => {
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const { state, dispatch } = useFormContext();

  const getVehicle = async (patent: string) => {
    try {
      setLoading(true);
      dispatch({
        type: 'CLEAN_DECLARATION_FORM_STATE',
        payload: null,
      });

      //TODO: En esta data buscar chasis number y engine number, hacer log de data
      const { data } = await getDeteailsVehicleByPantent(patent);

      dispatch({
        type: 'UPDATE_STEP',
        payload: 0,
      });

      //TODO: aquí se actualiza el state, solo valida que venga la propiedad (No te olvides de deebes agergar las propieades en el state y la interfaz)
      dispatch({
        type: 'UPDATE_VEHICLE_PATENT',
        payload: data,
      });

      // set initial data for Declarant
      dispatch({
        type: 'UPDATE_DECLARANT',
        payload: {
          identifierType: '',
          declarantIdentityNumber: '',
          declarantFullName: '',
          phoneNumber: '',
          emails: [],
        },
      });

      navigate(ACCIDENT_ROUTE);
    } catch (error) {
      setLoading(false);
      if (error?.status === 404) {
        setErrorMessage('La patente ingresada no se encuentra registrada en nuestros sistemas. Por favor ingrese una patente válida.');
      } else if (error?.status === 504) {
        setErrorMessage(
          'El tiempo de respuesta excede el máximo de espera, si el incidente continua por favor comunicarse con el equipo de soporte Gama.'
        );
      } else {
        setErrorMessage('En este momento no podemos procesar la solicitud.');
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log('useEffect is running');

    dispatch({
      type: 'SET_HEADER_TITLE',
      payload: 'Declaración de siniestros',
    });

    dispatch({
      type: 'UPDATE_STEP',
      payload: {
        plate: 0,
      },
    });
  }, []);

  const [valueSearchInput, setValueSearchInput] = useState('');

  return (
    <div style={{ flexGrow: 1 }}>
      <Row justify="center" className="search-view">
        <Col sm={24} xs={23}>
          <Row>
            <Col xl={8} lg={9} md={15} sm={18} xs={22}>
              <div>
                <div>
                  <p className="form_title">Identificación del vehículo siniestrado</p>
                </div>
                <div>
                  <span className="form_subtitle">Ingresa la patente de tu vehículo, sin puntos, sin espacios, ni guiones.</span>
                </div>
              </div>
              <Search
                name="patent"
                value={valueSearchInput}
                style={{
                  marginTop: '5px',
                  textTransform: 'uppercase',
                  width: '304px',
                }}
                onSearch={(value: string) => {
                  if (value?.length === 0) {
                    setErrorMessage('Por favor ingrese una patente.');
                  } else if (value?.length < 5 || value?.length > 7) {
                    setErrorMessage('Por favor ingrese una patente válida.');
                  } else {
                    getVehicle(value);
                  }
                }}
                onChange={(e) => {
                  setValueSearchInput(e?.target?.value?.toUpperCase());
                }}
                loading={loading}
                placeholder="Ej: TYBN34"
                required
              />
              {errorMessage && (
                <div className="error_message">
                  <span>{errorMessage}</span>
                </div>
              )}
            </Col>
          </Row>
          <Divider className="divider" />
          <Divider />
          <Row>
            <Col>
              <Return to={'..'} />
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};
